export const isGuid = (hash) => {
  return hash.match(/^([a-f\d]{8})(-[a-f\d]{4})(-[a-f\d]{4})(-[a-f\d]{4})(-[a-f\d]{12})$/i);
};
